import React, { Component } from 'react';
import Header from '../../header';
import Title from './title/title';
import { AuthService, ThreadService } from '../../service';
import AuthListener from "../../auth/auth_listener";
import './chat.css';
import ChatBottom from './bottom/bottom';
import firebase from '../../firebase/FirebaseProvider';
import ChatView from '@bit/super-mario.yoshi.chatview';

export default class Chat extends Component {

  constructor(props) {
    super(props);

    this.state = {
      threadId: null,
      channelId: null,
      chatToken: null
    }
  }

  async componentDidMount() {
    const threadId = this.getThreadIdFromUrl();
    const thread = await ThreadService.getThreadByThreadId(threadId);
    const chatToken = await AuthService.getAuthUserChatToken();

    this.setState(() => ({
      ...this.state,
      chatToken,
      thread
    }));
  }

  getThreadIdFromUrl() {
		const { pathname } = window.location;
    const [ str, threadId ] = pathname.match(/\/thread\/([a-zA-Z0-9]+)/);
    
    return threadId;
  }

  render() {
    const { chatToken, thread } = this.state;
    if (!thread) return null;

    const { channelId, id: threadId } = thread;

    return (
      <div className='chat-main-container'>
        <div className='simple-container chat-body-section chat-container'>
          <div className='chat-title'>
            <Title thread={thread} />
          </div>
          <div className='chat-body'>
            <ChatView channelId={thread.channelId} limit={false} />
          </div>
          {
            this.state.chatToken && (
              <div className='chat-bottom'>
                <ChatBottom chatToken={chatToken} channelId={channelId} threadId={threadId} />
              </div>
            )
          }
        </div>
      </div>
    )
  }
}
